import React from "react";
import { Box } from "@mui/material";
import RetailAnalyticsFilter from "./Filters/RetailAnalyticsFilter";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie } from "../../api_calls/userManagement";
import { resetBrandReportView, findEmbeddableId } from "../../api_calls/utils";
import { useDispatch, useSelector } from "react-redux";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";

const GeneralKpi = () => {
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const dispatchAction = useDispatch();
  const dashboardVariables = () => {
    let generalDashboardVariables = {};

    if (typeof userStateDate.embedded_general_kpi_stores !== "undefined" && typeof userStateDate.embedded_general_kpi_stores.store_ids !== "undefined" && userStateDate.embedded_general_kpi_stores.store_ids.length !== 0) {
      generalDashboardVariables = {
        ...generalDashboardVariables,
        Stores: userStateDate.embedded_general_kpi_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_general_kpi_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_general_kpi_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      generalDashboardVariables = {
        ...generalDashboardVariables,
        Date: {
          from: userStateDate?.embedded_general_kpi_date.from,
          to: endDate
        },
      }
    }

    return generalDashboardVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    resetBrandReportView();
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);
  return (
    <StyledMainBox component="main">
      {/* ---------- filter section ------------- */}
      <RetailAnalyticsFilter
        reduxKeyForStore="embedded_general_kpi_stores"
        reduxKeyForDate="embedded_general_kpi_date"
      />

      <Box height={1} />
      {/* ------------ dashboard from tableau ------------ */}
      {typeof userInfo.root_company_id !== "undefined" && typeof userStateDate.stores_list !== "undefined" && typeof userStateDate.store_dates !== "undefined" && (
        <Box>
          <Dashboard
            embedDashboardId={findEmbeddableId("retail_analytics", "general_kpi")}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": userInfo.root_company_id.toString(),
            }} />
        </Box>
      )}
    </StyledMainBox>
  );
};
// remove array if all user types are allowed. if only some are allowed, add them like below
export default AccessControl(GeneralKpi, ["analytics_can_view"], ["cyreen", "branch", "store"], ["retail_analytics_section", "general_analytics"]);
